/**
 * Microsoft Authentication Library (MSAL) Configuration
 * Handles Azure AD SSO for the frontend
 */

import { PublicClientApplication } from '@azure/msal-browser';

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || '',
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID || 'common'}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: true,
  },
};

export const loginRequest = {
  scopes: ['openid', 'email', 'profile', 'User.Read'],
  redirectUri: `${window.location.origin}/auth-redirect.html`,
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Initialize MSAL once at app startup and handle any pending redirects
export const msalReady = msalInstance.initialize().then(() => {
  return msalInstance.handleRedirectPromise();
}).catch((error) => {
  console.error('MSAL initialization error:', error);
});
